import React from "react";
import { Navigate } from "react-router-dom";
import { useParams } from "react-router";

const RedirectPartnerInfo = () => {
  const { id, code } = useParams();
  return (
    <Navigate to={`/admin/partner-infomation/${code}`} state={{ id, code }} />
  );
};

export default RedirectPartnerInfo;
